<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/148h4nO/tc-custom/9781504094870.jpg?1725419921899" alt="This image is the cover for the book Company She Keeps"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Company She Keeps
      </h1>
      <p class="bookDescription body article font2">
        <b>A spine-tingling suspense thriller that asks: How many bad men can one woman have in her life? </b><br/><br/><i>England, 1979</i>. After a childhood trauma, Rebecca struggles to build healthy relationships. Her on-again-off-again partner is a married police officer trying to catch the Yorkshire Ripper, who has just claimed his tenth victim.<br/><br/> Then Rebecca meets Larry, a charming American with a troubled past.<br/><br/> And of course there’s Mervyn, the creepy journalist she ended a brief relationship with, who will do anything to keep her in his life . . .<br/><br/> With three very different men craving her attention, and a serial killer on the loose, Rebecca soon finds herself in a twisted game of cat and mouse. Can any of these men be trusted? And could one of them in fact be a cold-blooded killer?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James Woolf
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5c596b4e